import React, { Component } from "react";
import MQSGUtil from "../mqsgUtil";
import "./IndexModal.css";

export default class IndexModal extends Component {
    constructor(props) {
        super(props);
    }
    setShow() {
        this.props.setShow(false)
    }
    render() {
        return (
            <div id="ppBoxHTML" className="overlay indexModal" style={{ display: this.props.show ? 'block' : 'none' }}>
                <div className="overlay-inner" style={{ background: '#fff', position: 'relative', maxHeight: '70%', overflowY: 'auto' }}>
                    <img
                        className="btn-close"
                        style={{}}
                        src="/img/education//icon-close-black.png"
                        onClick={() => this.setShow()}
                    />
                    <div style={{ padding: '60px' }}>
                        {this.props.keyValue === 1 && <WhyTarde />}
                        {this.props.keyValue === 2 && <HowTarde />}
                        {this.props.keyValue === 3 && <HowCalculate />}
                        {this.props.keyValue === 4 && <WarrantIssue />}
                        {this.props.keyValue === 5 && <StockCallwarrant />}
                        {this.props.keyValue === 6 && <StockPutWarrant />}
                    </div>
                </div>
            </div>
        )
    }

}
class WhyTarde extends Component {
    render() {
        return (
            <div className="main_body">
                <h3>Why trade stock warrants instead of shares?</h3>
                <p className="section-spacing">Warrants currently provide for investors, one of the highest leverage/gearing amongst all listed leveraged products in Singapore.</p>
                <div className="main_body_d1 section-spacing">
                    <div>
                        <img src="/img/education/Leverage.svg" alt="" />
                    </div>
                    <div className="main_body_flex">
                        <div><b>Leverage</b></div>
                        <div>They move between 5 to 30 times more than the price of the underlying asset. For example, a warrant with an effective gearing of 20 times will move, both positively and 
                            negatively, approximately, 20% given a 1% move in the underlying shares.
                        </div>
                    </div>
                </div>
                <div className="section-spacing">
                    <div>
                        <img src="/img/education/Limited_loss.svg" alt="" />
                    </div>
                    <div className="main_body_flex">
                        <div><b>Limited loss</b></div>
                        <div>The downside risk for warrants is capped at the initial investment as there are no margin calls. Hence, warrants provide leverage on the upside and limited loss for investors
                        </div>
                    </div>
                </div>
                <div className="main_body_d1">
                    <div>
                        <img src="/img/education/Low_capital_outlay.svg" alt="" />
                    </div>
                    <div className="main_body_flex">
                        <div><b>Low capital outlay</b></div>
                        <div>While a share can be costly for some investors, a warrant typically costs less than 20 cents
                        </div>
                    </div>
                </div>
            </div>  
        )
    }
}
class HowTarde extends Component {
    render() {
        return (
            <div className="main_body">
                <h3>How to select a warrant to trade?</h3>
                <div className="main_body_d1">
                    <div>
                        <img id="targetNumber" className="number" src="/img/education/1.svg" alt="" />
                    </div>
                    <div className="main_body_flex" style={{marginTop:'-10px'}}>
                        <div><b>View on the underlying</b></div>
                        <div>The price at which to enter and exit from a warrant is based on the entry and exit levels in the stock
                        </div>
                    </div>
                </div>
                <div className="">
                    <div>
                        <img id="targetNumber" src="/img/education/2.svg" alt="" className="img_right number"/>
                    </div>
                    <div className="main_body_flex">
                        <div><b>Decide on your holding period</b></div>
                        <div>As with all leveraged products, warrants are not meant as a long-term investment. The holding costs for warrants is known as time decay, where a warrant’s price erodes with 
                             time.
                        </div>
                    </div>
                </div>
                <p className="p_text">Use Macquarie’s <a href="/tools/selector" target="_blank">Warrant Selector</a> tool to help you see the maximum holding period (by weeks) that you should hold onto the warrant, based on your target underlying entry 
                    and exit levels, before the warrant gains are completely eroded by time decay.
                </p>
                <p className="p_text">Generally, you should choose an expiry longer than your intended holding period and avoid warrants expiring in the same month of the warrant purchase</p>
                <p className="p_text">Macquarie’s <a href="/tools/warrantcalculator" target="_blank">Warrant Calculator</a> estimates the time decay on your intended holding period.</p>
                <div className="main_body_d1">
                    <div>
                        <img id="targetNumber" className="number" src="/img/education/3.svg" alt="" />
                    </div>
                    <div className="main_body_flex">
                        <div><b>Determine your gearing level</b></div>
                        <div>For example, a warrant with 8 times effective gearing will move 8 times more, i.e. 8% for a 1% move in the underlying shares. The higher the effective gearing of the warrant, 
                            the riskier the warrant, as gearing works both ways.
                        </div>
                    </div>
                </div>
                <div className="">
                    <div>
                        <img  id="targetNumber" src="/img/education/4.svg" alt="" className="img_right number"/>
                    </div>
                    <div className="main_body_flex">
                        <div><b>Avoid warrants on wide spreads</b></div>
                        <div>What is a tight spread?
                        </div>
                    </div>
                </div>
                <p className="p_text" >Warrants priced less than <b>$0.200</b> have a $0.001 price spread between the bid and offer price.</p>
                <p className="p_text">Warrants priced <b>$0.200</b> and above have a $0.005 price spread between the bid and offer price.</p>
                <p className="p_text">How to calculate the cash settlement amount at expiry <b>you will receive a payment</b> (less a CDP admin of SGD 21.80)  within** 5** business days after expiry</p>
                <p className="p_text">Investors can see whether warrants are trading on tight spreads on Macquarie’s <a href="/tools/livematrix" target="_blank">Live Matrix</a></p>
            </div>
        )
    }
}
class HowCalculate extends Component {
    render() {
        return (
            <div className="main_body">
                <h3>How to estimate the investment amount?</h3>
                <p>
                    Apart from using effective gearing to estimate how much more the warrant will move relative to the underlying they track, gearing can act as an estimation for the investment amount an 
                    investor can place in the warrants relative to shares.
                </p>
                <div  className="main_body_d1" style={{display:'block'}}>
                    <p>
                        For example, if a DBS shareholder had to liquidate his share investment for cash, but saw short-term bullishness in DBS shares, he or she can buy a call warrant with an <b>effective gearing 
                        of 8 times.</b>
                    </p>
                    <p>
                        If so, assuming an original investment of S$100,000 in DBS shares, he/she will therefore invest only <b>S$100,000 / 8 times = S$12,500</b> in the DBS call warrant.
                    </p>
                    <p>
                        Assuming this call warrant costs $0.125, this investor will buy <b>$12,500 / $0.125 = </b>approximately 100,000 units of this call warrant to gain the same exposure to movements in DBS shares 
                        in the short-term.
                    </p>
                </div>
                <p style={{marginTop:'20px'}}>
                    The <a href="/tools/exposuresimulator" target="_blank">Exposure Simulator</a> helps investors estimate the warrant investment amount to either replicate a stock exposure with lesser capital outlay, or to hedge your current stock exposure
                </p>
            </div>
        )
    }
}
class WarrantIssue extends Component {
    render() {
        return (
            <div className="">
                <h3>How to calculate the cash settlement amount at expiry?</h3>
                <p>
                    Your stock warrant will be automatically exercised if you hold it until expiry. If the cash settlement amount is positive, Macquarie will credit the cash settlement amount (nett of the $21.80 CDP handling fee) in your bank account registered with CDP within 5 business days after expiry.
                </p>
                <div style={{textAlign: 'center'}}>
                    <img src="/img/education/Stock_call_warrant_expiry_formula.png" alt="" style={{width:'70%'}}/>
                </div>
                <div style={{textAlign: 'center'}}>
                    <img src="/img/education/Stock_put_warrant_expiry_formula.png" alt="" style={{width:'70%'}}/>
                </div>
                <div  style={{textAlign: 'center'}}>
                        <p style={{textAlign:'right',width:'85%'}}>*for Hong Kong stock warrants</p>
                </div>
                <p>The FX rate component takes into consideration the Hong Kong stock warrants that are denominated in HKD and not SGD.</p>
                <p>If the warrant expires with zero or negative value, investors need not do anything.</p>
            </div>
        )
    }
}
class StockCallwarrant extends Component {
    render(){
        return (
            <div className="">
                <h3>Stock call warrant: </h3>
                <p>If you have a bullish view on DBS in the short-term, you can consider buying a DBS call warrant. Example as follows:</p>
                <img src="/img/education/123451.png" alt="" style={{width:'100%'}}/>
                <br />
                <br />
                <p>Assuming your view is right, you would have a 188% return in the DBS call warrant which is 8 times more than that of the stock move. At the same time, the warrant costs 3.4 Singapore cents, a fraction of the underlying share prices.</p>
                <p>This is an example of gearing at work and the advantage that warrants offer i.e. a greater potential profit as a percentage of your invested capital.</p>
                <p>However, gearing works in both directions, so greater potential returns also come with greater risks.</p>
                <p style={{color:'#7F7F7F'}}>*Past performance is not indicative of future performance. Example is used here for illustration only.</p>
            </div>
        )
    }
}
class StockPutWarrant extends Component {
    render(){
        return (
            <div className="">
                <h3>Stock put warrant: </h3>
                <p>If you have a bearish view on Alibaba shares, you can consider buying an Alibaba put warrant. Example as follows:</p>
                <img src="/img/education/555141.png" alt="" style={{width:'100%'}}/>
                <br />
                <br />
                <p>Assuming your view is right, you would have a 94% return in the Alibaba put warrant which is 6 times more than that of the stock move. At the same time, the warrant costs 8 Singapore cents, a fraction of the underlying share prices.</p>
                <p>This is an example of gearing at work and the advantage that warrants offer i.e. a greater potential profit as a percentage of your invested capital.</p>
                <p>However, gearing works in both directions, so greater potential returns also come with greater risks.</p>
                <p style={{color:'#7F7F7F'}}>*Past performance is not indicative of future performance. Example is used here for illustration only.</p>
            </div>
        )
    }
}